import React, { useContext } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import constants from "../../../constants";
import { LibraryContext } from "../../../context/LibraryContext";
import ModuleHooks from "../../../Hooks/ModuleHooks";
import Popup from "../../CommonComponents/Popup";
// import { getDataFromStorage } from "../../../util";
import LibraryUtils, { libTypeName } from "./LibraryUtils";
import TestSvgIcon from "../../../Svg/TestSvgIcon";
import { useEffect } from "react";
import LibraryStats from "./LibraryStats";
import QuestionList from "./QuestionList";
// import _ from "lodash";

const LibraryDetails = (props) => {
  const { type, testid, questionid } = useParams();
  const { pathname } = useLocation();
  const { setSearchText, setSelectedTopic } = useContext(LibraryContext);
  const { isCommonPopup } = ModuleHooks();
  const view = [`/library/${type}/shared`];

  const contentOrAssignment = [
    constants.libTypeIds.ASSIGNMENT,
    constants.libTypeIds.CONTENT,
  ];

  const handleOnSearch = (event) => {
    setSearchText(event.target.value);
  };

  const onAdd = () => {
    props.que({ published: 0 });
    props.setisqueReport(false);
  };

  const uniqueRoute = [
    `/library/${type}/questions`,
    `/library/${type}/questions/${questionid}`,
    `/library/${type}/contententry`,
    // `/library/${type}/testlist`,
    `/library/${type}/test/create`,
    `/library/${type}/assignment`,
    `/library/${type}/assignment/${questionid}`,
    `/library/${type}/test/${testid}`,
    "/library/mock/test",
    "/library/mock/test/create",
    `/library/mock/test/${testid}`,
  ];

  useEffect(() => {
    console.log("UseEffect is calling:", type);

    // if (!uniqueRoute.includes(pathname)) {
    setSelectedTopic(null);
    setSearchText("");
    // }
  }, [type, setSearchText, setSelectedTopic]);

  return (
    <div
      className="libdContainer"
      style={{
        marginTop: "7vh",
        padding: uniqueRoute.includes(pathname) ? "0px" : "12px 24px 24px",
        gap: pathname === `/library/${type}/questionlist` ? "0px" : "16px",
      }}
    >
      <div>
        {/* {!contentOrAssignment.includes(parseInt(type)) &&
        !uniqueRoute.includes(pathname) ? (
          <div className="libdTitle car" style={{ padding: "9px 16px" }}>
            <TestSvgIcon
              active={true}
              disable={false}
              libType={parseInt(type)}
            />
            {libTypeName[type]}
          </div>
        ) : null} */}

        {/* {view.includes(pathname) ? ( */}
        <React.Fragment>
          {!uniqueRoute.includes(pathname) ? (
            <>
              {!contentOrAssignment.includes(+type) && <LibraryStats />}
              <LibraryUtils onSearch={handleOnSearch} onAdd={onAdd} que={props.que} />
            </>
          ) : null}
        </React.Fragment>
        {/* ) : null} */}
      </div>
      <Outlet />
      {isCommonPopup && <Popup />}
    </div>
  );
};

export default LibraryDetails;
